import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { UserAnalyticsService } from "@analytics/index";

import useEffectAfterMount from "@hooks/useEffectAfterMount";
import usePrevious from "@hooks/usePrevious";

import { usePopupState } from "@store/popupStore";

import theme from "@theme/index";

import { extractTextFromJsx } from "@utilities/extractStringFromJsx.js";

/**
 * `Modal` component for displaying a dialog window.
 *
 * The open state is controlled by a central store. This allows for a single modal component within the entire app
 * whose content and visibility can be set when the modal is opened and reset on subsequent calls.
 * Displays a dialog window with a title, content, and close button.
 *
 * @returns The Modal dialog component.
 */
export default function BlockingModal() {
  const { blockingModal } = usePopupState();

  const { content, isOpen, title } = blockingModal;

  const previousOpen = usePrevious(isOpen);

  return isOpen ? (
    <Dialog aria-labelledby="dialog-title" maxWidth="md" open={isOpen}>
      <DialogTitle
        id="dialog-title"
        sx={{
          alignItems: "center",
          borderBottom: `1px solid ${theme.palette.borderColor.dark}`,
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
    </Dialog>
  ) : (
    <div />
  );
}
